var render, staticRenderFns
import script from "./ItemRender.vue?vue&type=script&lang=js"
export * from "./ItemRender.vue?vue&type=script&lang=js"
import style0 from "./ItemRender.pcss?vue&type=style&index=0&id=2e7ef190&prod&scoped=true&lang=pcss&external"


/* normalize component */
import normalizer from "!../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7ef190",
  null
  
)

export default component.exports